import React from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { ThemeProvider } from './contexts/ThemeContext'
import { AuthProvider } from './contexts/AuthContext'
import { Toaster, ToastBar, toast } from 'react-hot-toast'

// Public Pages
import LandingPage from './pages/LandingPage'
import CityMarketing from './pages/CityMarketing'
import CityReport from './pages/CityReport'
import Login from './pages/Login'
import FAQ from './pages/FAQ'
import Maggie from './pages/Maggie'

// Private Pages
import Dashboard from './pages/Dashboard'
import UserAdmin from './pages/UserAdmin'
import IssueAdmin from './pages/IssueAdmin'
import CityAdmin from './pages/CityAdmin'
import CityAdminDetail from './pages/CityAdminDetail'
import CityAdminNew from './pages/CityAdminNew'
import AppAdmin from './pages/AppAdmin'
import UserProfile from './pages/UserProfile'
import DepartmentAdmin from './pages/DepartmentAdmin'

// Components
import PrivateRoute from './components/PrivateRoute'
import SuperuserRoute from './components/SuperuserRoute'
import Layout from './components/Layout'
import ScrollToTop from './components/ScrollToTop'

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
          <ScrollToTop />
          <div className="min-h-screen bg-gray-50 dark:bg-gray-900 transition-colors duration-200">
            <Toaster position="top-right">
              {(t) => (
                <ToastBar toast={t}>
                  {({ icon, message }) => (
                    <div className="flex items-start gap-3 w-full">
                      {t.type !== 'loading' ? (
                        <button
                          type="button"
                          onClick={() => toast.dismiss(t.id)}
                          className="flex-shrink-0 border-0 bg-transparent p-0 cursor-pointer leading-none"
                          aria-label="Dismiss notification"
                        >
                          {icon}
                        </button>
                      ) : (
                        <span className="flex-shrink-0">{icon}</span>
                      )}
                      <span className="flex-1">{message}</span>
                    </div>
                  )}
                </ToastBar>
              )}
            </Toaster>
            <Routes>
              {/* Public Routes */}
              <Route path="/" element={<LandingPage />} />
              <Route path="/cities" element={<CityMarketing />} />
              <Route path="/cities/report/:domain" element={<CityReport />} />
              <Route path="/login" element={<Login />} />
              <Route path="/faq" element={<FAQ />} />
              <Route path="/maggie" element={<Maggie />} />
              
              {/* Private Routes */}
              <Route path="/dashboard" element={
                <PrivateRoute>
                  <Layout>
                    <Dashboard />
                  </Layout>
                </PrivateRoute>
              } />
              <Route path="/user-admin" element={
                <PrivateRoute>
                  <Layout>
                    <UserAdmin />
                  </Layout>
                </PrivateRoute>
              } />
              <Route path="/issue-admin" element={
                <PrivateRoute>
                  <Layout>
                    <IssueAdmin />
                  </Layout>
                </PrivateRoute>
              } />
              <Route path="/city-admin" element={
                <PrivateRoute>
                  <SuperuserRoute>
                    <Layout>
                      <CityAdmin />
                    </Layout>
                  </SuperuserRoute>
                </PrivateRoute>
              } />
              <Route path="/city-admin/new" element={
                <PrivateRoute>
                  <SuperuserRoute>
                    <Layout>
                      <CityAdminNew />
                    </Layout>
                  </SuperuserRoute>
                </PrivateRoute>
              } />
              <Route path="/city-admin/:id" element={
                <PrivateRoute>
                  <SuperuserRoute>
                    <Layout>
                      <CityAdminDetail />
                    </Layout>
                  </SuperuserRoute>
                </PrivateRoute>
              } />
              <Route path="/departments" element={
                <PrivateRoute>
                  <Layout>
                    <DepartmentAdmin />
                  </Layout>
                </PrivateRoute>
              } />
              <Route path="/app-admin" element={
                <PrivateRoute>
                  <Layout>
                    <AppAdmin />
                  </Layout>
                </PrivateRoute>
              } />
              <Route path="/user-profile" element={
                <PrivateRoute>
                  <Layout>
                    <UserProfile />
                  </Layout>
                </PrivateRoute>
              } />
            </Routes>
          </div>
        </Router>
      </AuthProvider>
    </ThemeProvider>
  )
}

export default App
